import { button } from "@/helper/locale/base/base_button.th"
import base_otp from "@/helper/locale/base/base_otp.th"
import { date } from "@/helper/locale/base/base_date.th"

export default {
    base_button: button,
    base_otp,
    base_date: date,

    paywithpoint: {
        avaliable_points: 'คะแนนที่คุณมีทั้งหมด',
        can_redeem: 'คุณสามารถแลกได้สูงสุด',
        create_voucher: 'สร้างโค้ดส่วนลดของฉัน',
        minimum_point: 'กรุณากรอกอย่างน้อย {0} คะแนน',
        minimum_bath: 'กรุณากรอกอย่างน้อย {0} บาท',
        points_amount: 'ระบุมูลค่าที่ต้องการแลก',
        point: 'คะแนน',
        code_value: 'มูลค่า',
        baht: 'บาท',
        switch_unit: 'สลับหน่วย',
        create_btn: 'สร้างเลย !',
        terms_conditions: 'ข้อตกลงและเงื่อนไข',
        inputLbl: {
            name: 'คะแนน',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        inputLblBaht: {
            name: 'บาท',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
    },

    err: {
        err_min_point: "กรุณากรอกอย่างน้อย {0} คะแนน",
        err_min_baht: "กรุณากรอกอย่างน้อย {0} บาท",
        err_max_point: "คุณสามารถแลกสิทธิ์ได้ไม่เกิน {0} คะแนน ต่อครั้ง",
        err_max_baht: "คุณสามารถแลกสิทธิ์ได้ไม่เกิน {0} บาท ต่อครั้ง",
        err_limit_peruser: "ขออภัย คุณใช้สิทธิ์ครบตามจำนวนแล้ว",
        err_limit_soldout: "ขออภัย สิทธิ์ครบตามจำนวนแล้ว",
        err_limit_user_point: "คุณสามารถแลกได้ไม่เกิน {0} คะแนน เนื่องจากคุณใช้สิทธิ์ใกล้ครบตามจำนวนแล้ว",
        err_limit_user_baht: "คุณสามารถแลกได้ไม่เกิน {0} บาท เนื่องจากคุณใช้สิทธิ์ใกล้ครบตามจำนวนแล้ว",
        err_limit_app_point: "คุณสามารถแลกได้ไม่เกิน {0} คะแนน เนื่องจากจำนวนสิทธิ์ใกล้ครบตามจำนวนแล้ว",
        err_limit_app_baht: "คุณสามารถแลกได้ไม่เกิน {0} บาท เนื่องจากจำนวนสิทธิ์ใกล้ครบตามจำนวนแล้ว"
    },

    confirm_popup: {
        confirm_create:'ยืนยันการสร้าง',
        confirm_detail:'กรุณากด "ยืนยัน" เพื่อยืนยันการใช้',
        confirm_detail_1:'คะแนน สําหรับสร้างโค้ดส่วนลด',
        confirm_detail_2:'บาท',
        confirm_warning:'โปรดระวัง! โค้ดนี้ต้องใช้ทันที หรือจนกว่าหมดเวลาที่กำหนดเท่านั้น​',
        confirm_btn:'ตกลง',
        cancel_btn:'ยกเลิก',
    },

    redeem_success: {
        create_success:'สร้างโค้ดส่วนลดสำเร็จ !',
        detail:'กรุณากด "ใช้เลย !"  เพื่อแสดงโค้ดให้ร้านค้า',
        use_btn:'ใช้เลย !',


        qr_redeem_success: 'Redeem Successfully !',
        qr_redeem_success_detail: 'You have been redeemed point successfully.',

        qr_redeem_error: 'Redeem Failed !',
        qr_redeem_error_detail: 'Plase try again.',
    },

    serial: {
        title: 'โค้ดส่วนลด มูลค่า',
        baht: 'บาท',

        qr_code: 'คิวอาร์โค้ด',
        barcode: 'บาร์โค้ด',
        code: 'โค้ด',

        show_code_at_shop: 'กรุณาแสดงโค้ดที่ร้านค้าเพื่อใช้เป็นส่วนลด',
        expire_in: 'โค้ดหมดอายุภายใน',
        redeem_on: 'สร้างโค้ดส่วนลดวันที่ {0}',

        condition:'เงื่อนไข',
        close_btn: 'ปิด',

        code_expired: 'รหัสหมดอายุ',
    },

    terms_conditions: {
        title: 'ข้อตกลงและเงื่อนไข',
        close: 'ปิด'
    },

    alert: {
        close_btn: 'ปิด',
        no_point_title: 'กรุณาระบุคะแนนที่ต้องการแลก',
        no_point_msg: 'กรุณากรอกอย่างน้อย {0} คะแนน เพื่อสร้างโค้ดส่วนลด',

        redeem_title: 'ขออภัย พบปัญหาการเชื่อมต่อระบบ',
        redeem_msg: 'กรุณาลองใหม่อีกครั้งหรือกลับมาใหม่ในอีก 15 นาที',

        limit_user_title: 'ขออภัย คุณใช้สิทธิ์ครบตามจำนวนแล้ว',
        limit_user_msg: 'กรุณาลองใหม่อีกครั้งในเดือนหน้า',

        limit_per_user_remaining_title: "ขออภัย คุณใช้สิทธิ์ใกล้ครบตามจำนวนแล้ว",
        limit_per_user_remaining_msg: "คุณสามารถแลกได้ไม่เกิน {0} คะแนน",

        limit_per_app_remaining_title: "ขออภัย จำนวนสิทธิ์ใกล้ครบตามจำนวนแล้ว",
        limit_per_app_remaining_msg: "คุณสามารถแลกได้ไม่เกิน {0} คะแนน",

        limit_app_title: 'ขออภัย สิทธิ์ครบตามจำนวนแล้ว',
        limit_app_msg: 'กรุณาลองใหม่อีกครั้งภายหลัง',

        maximum_user_title: "ขออภัย คุณกรอกจำนวนสิทธิ์เกินกำหนด",
        maximum_user_msg: "คุณสามารถแลกสิทธิ์ได้ไม่เกิน {0} คะแนนต่อครั้ง",

        limit_app_user_title: 'ขออภัย สิทธิ์ครบตามจำนวนแล้ว',
        limit_app_user_msg: 'กรุณาลองใหม่อีกครั้งภายหลัง',

        close_Showcode_msg: 'ใช้โค้ดส่วนลดได้ตามที่ระยะเวลาที่กำหนดเท่านั้น หากยังไม่หมดเวลาการใช้โค้ด สามารถดูได้ที่ประวัติการรับสิทธิ์',

        point_not_enought_title: "Your point is not enough",
        point_not_enought_msg: "We're sorry that you cannot redeem this, Please come back later.",

    },

    welcome: {
        title: "สร้างโค้ดส่วนลดได้ตามใจคุณ",
        msg: "สามารถระบุคะแนนเพื่อสร้างโค้ดส่วนลดได้ตามที่ต้องการ และใช้ในช่วงเวลาที่กำหนด กดใช้สิทธิ์เมื่อต้องการใช้เท่านั้น"
    },

}
